import { render } from "./TableViewCollection.vue?vue&type=template&id=3e599218"
import script from "./TableViewCollection.vue?vue&type=script&lang=js"
export * from "./TableViewCollection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__